import React, { Component } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  withStyles,
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { IconButton } from "@material-ui/core";
import { callApi } from "../../../crud/auth.crud";
import swal from "sweetalert";


const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

export default class ShepheredTable extends Component {
  deleteDate = async (sunday_id) => {
    try {
      const result = await callApi("shepherd-delete-date", { sunday_id });
      if (result.status === 200) {
        swal("Date Deleted Successfully!", "", "success");
        this.props.getAllSessions();
        // this.setState({ tableData: result.data.data });
      } else {
        swal("Oops!", "Please try again!!", "error");
      }
    } catch {
      swal("Oops!", "Network Error!!", "error");
    }
  };
  deleteHandlerConfirm = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.deleteDate(id);
        // swal("Data has been deleted!", {
        //   icon: "success",
        // });
      }
    });
  };

  render() {
    const { tableData } = this.props;
    return (
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">Week Date</StyledTableCell>
              <StyledTableCell align="center">Week Day</StyledTableCell>
              <StyledTableCell align="center">Remove Entry</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData &&
              tableData.map((row, i) => (
                <StyledTableRow key={i}>
                  <StyledTableCell align="center">{row.date}</StyledTableCell>
                  <StyledTableCell align="center">{row.day}</StyledTableCell>
                  <StyledTableCell align="center">
                    {" "}
                    <IconButton
                      aria-label="Delete"
                      onClick={() => this.deleteHandlerConfirm(row.sundayID)}
                    >
                      <DeleteOutlineIcon style={{ color: "red" }} />
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}
